// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","icon":"Header_icon__1sL6t","text":"Header_text__IkRmy","logo":"Header_logo__3T0lc"};